import { render, staticRenderFns } from "./flowTable.vue?vue&type=template&id=29229571&scoped=true"
import script from "./flowTable.vue?vue&type=script&lang=js"
export * from "./flowTable.vue?vue&type=script&lang=js"
import style0 from "./flowTable.vue?vue&type=style&index=0&id=29229571&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29229571",
  null
  
)

export default component.exports